import {
  ASSIGNMENT_NOTIFICATION_FAILURE_FALLBACK,
  ASSIGNMENT_NOTIFICATION_FAILURE_LABELS,
  ROLE_LABELS,
  TEAM_LEVEL_LABELS,
  type AssignmentNotification,
  type Role,
  type TeamLevel,
} from '@easyhelp/shared';

/** Etichetta dell'escalation al secondo livello (DEC-004). */
export const ESCALATION_LABEL = 'Escalation';

/** Etichetta di chi è sul ticket ma è uscito dal team dopo l'assegnazione. */
export const REMOVED_MEMBER_LABEL = 'Non più nel team';

/** Ruolo e livello in una riga: «Sviluppo · Secondo livello · Sviluppo»; vuoto se non noti. */
export function roleAndLevel(member: { role: Role | null; level: TeamLevel | null }): string {
  return [member.role && ROLE_LABELS[member.role], member.level && TEAM_LEVEL_LABELS[member.level]]
    .filter(Boolean)
    .join(' · ');
}

/** Perché una notifica non è partita, in italiano. */
export function notificationFailureText(failure: string | null): string {
  return (failure && ASSIGNMENT_NOTIFICATION_FAILURE_LABELS[failure]) ?? ASSIGNMENT_NOTIFICATION_FAILURE_FALLBACK;
}

/** Esito della notifica di assegnazione, in una frase. */
export function notificationText(notification: AssignmentNotification): string {
  switch (notification.outcome) {
    case 'inviata':
      return `Notifica inviata a ${notification.address}.`;
    case 'in_invio':
      return `Notifica in invio a ${notification.address}.`;
    case 'non_inviata':
      return `Notifica non inviata a ${notification.address}: ${notificationFailureText(notification.failure)}.`;
  }
}
